import styled from "styled-components";
import { ColorTheme, BorderRadiusTheme, SpacingTheme } from "../../../components/globaStyledComponents/globalStyledComponentsStyling";

export const SkeletonViewListingPageContainer = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    background: white;
    box-shadow: 1.3px 3px 16px 0px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;
    z-index: 3;
    &::-webkit-scrollbar {
        display: none;
    }

    @media (min-width: 768px) {
        width: calc(100% - 16px);
        margin-left: 8px;
        margin-top: 80px;
        margin-right: 8px;
        border-radius: 16px;
        height: 100vh;
        background: #fff;
        backdrop-filter: blur(32px);
    }
`;

export const SkeletonDesktopHeaderContainer = styled.div`
    position: fixed;
    top: 0px;
    height: 80px;
    width: 100%;
    padding: 0 24px;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    pointer-events: none;
    background: #fafafa;
    
    @media (max-width: 767px) {
        display: none;
    }
`;

export const SkeletonDesktopHeaderLeft = styled.div`
    display: flex;
    align-items: center;
    pointer-events: auto;
    cursor: pointer;
    
    img {
        height: 32px;
        width: auto;
    }
`;

export const SkeletonCarouselPageContainer = styled.div`
    z-index: 1;
    position: relative;
    margin-bottom: -13px;
    @media (min-width: 768px) {
        margin-bottom: auto;
    }
`;

export const SkeletonCarouselWrapper = styled.div`
    width: 100%;
    padding-bottom: 32px;
    margin-left: -25vw;
    width: calc(100% + 25vw);

    @media (max-width: 767px) {
        margin-left: 0;
        width: 100%;
        padding-bottom: 0;
    }
`;

export const ViewListingContainer = styled.div`
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 24px;
    
    @media (max-width: 767px) {
        padding: 0;
        background: rgba(255, 255, 255, 0.35);
        backdrop-filter: blur(80px);
        border-top-left-radius: 24px;
        border-top-right-radius: 24px;
        margin-top: -12px;
        position: relative;
        padding: 24px 24px 0;
        z-index: 2;
    }

    @media (min-width: 768px) {
        padding: 0 40px;
    }

    @media (min-width: 1280px) {
        padding: 0 80px;
    }
`;

export const ViewListingTopContainerWrapper = styled.div`
    display: flex;
    width: 100%;
    gap: 40px;
    // margin-top: 32px;
    @media (min-width: 1280px) {
        gap: 96px;
    }
`;

export const ViewListingTopContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    @media (min-width: 768px) {
        width: 100%;
    }

    @media (min-width: 1024px) {
        width: 58%;
        flex: 1;
    }

    @media (min-width: 1280px) {
        max-width: 656px;
        flex: 1;
    }
`;

export const ViewListingFeaturedImage = styled.div`
    width: 100%;
    height: 320px;
    background-color: ${ColorTheme.Grey2.color};
    
    @media (min-width: 768px) {
        height: 48vh;
    }
    
    @media (min-width: 1024px) {
        height: 58vh;
        max-height: 560px;
    }
`;

export const ViewListingTitleWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    @media (min-width: 768px) {
        justify-content: center;
    }
`;

export const ViewListingTitleTitle = styled.div`
    width: 100%;
    height: 32px;
    background-color: ${ColorTheme.Grey2.color};
    border-radius: 8px;
    max-width: 80%;
`;

export const ViewListingTitleSubtitle = styled.div`
    width: 180px;
    height: 20px;
    margin-top: 16px;
    background-color: ${ColorTheme.Grey2.color};
    border-radius: 5px;
    @media (min-width: 768px) {
        width: 356px;
    }
`;

export const ViewListingTitleAmenities = styled.div`
    width: 200px;
    height: 18px;
    margin-top: 4px;
    background-color: ${ColorTheme.Grey2.color};
    border-radius: 5px;
    @media (min-width: 768px) {
        width: 300px;
    }
`;

export const ViewListingAmenitiesContainer = styled.div`
    @media (min-width: 768px) {
    }
`;

export const ViewListingSubtitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    width: 100%;
`;

export const ViewListingSubtitlePlaceType = styled.div`
    width: 60%;
    height: 20px;
    background-color: ${ColorTheme.Grey2.color};
    border-radius: 8px;
`;

export const ViewListingSubtitleHostedBy = styled.div`
    width: 40%;
    height: 20px;
    background-color: ${ColorTheme.Grey2.color};
    border-radius: 8px;
    margin-top: 4px;
`;

export const ViewListingHeaderProfileImageWrapper = styled.div`
    display: grid;
    grid-row: 1/2;
    grid-column: 1/2;
    grid-template-columns: 100%;
    grid-template-rows: 100%;
    height: fit-content;
    width: fit-content;
    padding: 0;
    background: none;
    border: none;
`;

export const ViewListingSubtitleImage = styled.div`
    grid-row: 1/2;
    grid-column: 1/2;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: ${ColorTheme.Grey2.color};
    @media (min-width: 768px) {
        width: 56px;
        height: 56px;
    }
`;

export const ViewListingAmenitiesWrapper = styled.div`
    width: 100%;
    border: 1px solid ${ColorTheme.Grey2.color};
    border-radius: ${BorderRadiusTheme.radius_12.borderRadius};
    display: flex;
    flex-wrap: wrap;
    height: 202px;
    align-content: space-evenly;

    @media (min-width: 768px) {
        height: 150px;
    }
`;

export const ViewListingAmenitie = styled.div`
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    @media (min-width: 768px) {
        width: 25%;
    }
`;

export const ViewListingAmenitieIcon = styled.div`
    width: 24px;
    height: 24px;
    margin: 0;
    padding: 0;
    border-radius: 5px;
    background-color: ${ColorTheme.Grey2.color};
    @media (min-width: 768px) {
        width: 32px;
        height: 32px;
    }
`;

export const ViewListingAmenitieText = styled.div`
    margin-top: 12px;
    width: 50%;
    max-width: 90px;
    height: 17px;
    border-radius: 5px;
    background-color: ${ColorTheme.Grey2.color};
`;

export const ViewListingDescriptionWrapper = styled.div`
    width: 100%;
    margin: 0;
    padding: ${SpacingTheme.spacing_400.padding} 0 ${SpacingTheme.spacing_500.padding};
    border-bottom: 1px solid ${ColorTheme.Grey2.color};

    @media (min-width: 768px) {
        padding: ${SpacingTheme.spacing_600.padding} 0;
        border: 0;
    }
`;

export const ViewListingDescriptionText = styled.div`
    width: 250px;
    height: 25px;
    background-color: ${ColorTheme.Grey2.color};
    border-radius: 5px;
`;

export const ViewListingAboutLocationWrapper = styled.div`
    width: 100%;
    padding: ${SpacingTheme.spacing_500.padding} 0;
    border-top: 1px solid ${ColorTheme.Grey2.color};
`;

export const ViewListingAboutLocationTitle = styled.div`
    width: 240px;
    height: 32px;
    background-color: ${ColorTheme.Grey2.color};
    border-radius: 5px;
    margin-bottom: 24px;
    @media (min-width: 768px) {
        width: 541px;
    }
`;

export const ViewListingMapWrapper = styled.div`
    width: 100%;
    height: 400px;
    border-radius: ${BorderRadiusTheme.radius_12.borderRadius};
    background-color: ${ColorTheme.Grey2.color};
`;

export const ViewListingRightMenuContainer = styled.div`
    display: none;

    @media (min-width: 1024px) {
        width: 33%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    @media (min-width: 1280px) {
        width: 376px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
    }
`;
